'use es6';

import createAction from 'flux-actions/createAction';
import { RECEIVED_HUBDB_ROWS, RECEIVED_HUBDB_TABLE, REQUESTED_HUBDB_ROWS, REQUESTED_HUBDB_ROWS_FAILED, REQUESTED_HUBDB_TABLE, REQUESTED_HUBDB_TABLE_FAILED } from './ActionTypes';
export const requestHubDbTable = createAction(REQUESTED_HUBDB_TABLE);
export const receiveHubDbTable = createAction(RECEIVED_HUBDB_TABLE, hubDbTable => ({
  hubDbTable
}));
export const requestedHubDbTableFailed = createAction(REQUESTED_HUBDB_TABLE_FAILED, error => ({
  error
}));
export const requestHubDbRows = createAction(REQUESTED_HUBDB_ROWS);
export const receiveHubDbRows = createAction(RECEIVED_HUBDB_ROWS, hubDbRows => ({
  hubDbRows
}));
export const requestedHubDbRowsFailed = createAction(REQUESTED_HUBDB_ROWS_FAILED, error => ({
  error
}));